import axios from "axios";

export const API = axios.create({
  // baseURL: "http://localhost:5030/",
  baseURL: "https://donalternuser.skyapi.store/",

});
